import { useMemo } from 'react'

import { useSelectedChannel } from '~publish/pages/Channel/ChannelContext'

import { countActiveSlots } from '../utils/countActiveSlots'

type UseMatchPostingGoalReturn = {
  isDisabled: boolean
  disabledMessage: string | undefined
  goal: number
  activeSlotCount: number
}

const useMatchPostingGoal = (): UseMatchPostingGoalReturn => {
  const channelData = useSelectedChannel()
  const { postingSchedule, postingGoal } = channelData ?? {
    postingSchedule: undefined,
    postingGoal: undefined,
  }
  const goal = postingGoal?.goal ?? 0
  const activeSlotCount = useMemo(
    () => countActiveSlots(postingSchedule),
    [postingSchedule],
  )
  const isDisabled = goal === 0 || goal <= activeSlotCount
  const disabledMessage = useMemo(() => {
    if (goal === 0) {
      return "You have not set a weekly Posting Goal for this channel. You can set the number of times you'd like to post each week above."
    }
    if (goal === activeSlotCount) {
      return 'You have the same number of posting slots as your goal. You can adjust your goal in channel settings.'
    }
    if (goal < activeSlotCount) {
      return 'You have more posting slots than your goal. You can adjust your goal in channel settings.'
    }
    return undefined
  }, [goal, activeSlotCount])

  return {
    isDisabled,
    disabledMessage,
    goal,
    activeSlotCount,
  }
}

export default useMatchPostingGoal
